/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import FormatEnum from '../../../core/format-enum';
import UpdatePlatform from '../../../core/update/update-platform';
import Platform from '../../../platform/platform';

/**
 * Správce aplikace pro standardní webové technologie.
 * @implements {AppManager}
 * @memberof AdapterWeb
 */
class AppManager {
  /**
   * Vytvoří instanci.
   * @returns {AppManager} Nová instance.
   */
  constructor() {
    this.updateUrl = location.href;
  }

  /** @inheritdoc */
  exit() {
    // #484 - Prázdná akce na platformě web, ochrana proti ztrátě řízení (původně se načítalo about:blank)
    return Promise.resolve();
  }

  /** @inheritdoc */
  finishUpdate() {
    return Promise.resolve();
  }

  /** @inheritdoc */
  getBuildPlatform() {
    return Promise.resolve(Platform.Web);
  }

  /** @inheritdoc */
  getFormat() {
    return Promise.resolve(FormatEnum.HTML);
  }

  /** @inheritdoc */
  getRuntimePlatform() {
    return Promise.resolve(Platform.Web);
  }

  /** @inheritdoc */
  getUpdatePlatform() {
    // Web má jedinou platformu, bez verzování apod.
    return Promise.resolve(UpdatePlatform.Web);
  }

  /** @inheritdoc */
  getUpdateUrl() {
    return new Promise((resolve) => resolve(this.updateUrl));
  }

  /** @inheritdoc */
  update(url) {
    // #484 - Prázdná akce na platformě web, ochrana proti případné změně domény
    return Promise.resolve();
  }
}

export default AppManager;
